import React, { useState, useEffect } from 'react';
import {Gator, Small, Bar}  from './style';
import {BrowserRouter as Router, Switch, Route, Link} from "react-router-dom";

function Nav (){
    return(
        <Bar>
            <Link to='/' style={{textDecoration: 'none', color: 'black'}}>
                <Gator>
                    Nude Goals
                </Gator>
            </Link>
            <Link to='message' style={{textDecoration: 'none'}}> 
                <Small>message boards</Small> 
            </Link>
        </Bar>
    )
}

export default Nav;